import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
const theme = createTheme({
  palette: {
    background: {
      main: '#000000',
      contrastText: '#ffffff',
    },
    light: {
      main: '#ffffff',
      contrastText: '#000000',
    },
    secondary: {
      main: '#bb743a',
      dark: '#bb743a',
      light: '#bb743a',
      contrastText: '#ffffff',
    },
    primary: {
      main: '#BB743A',
      dark: '#87480d',
      light: '#f1a366',
      contrastText: '#ffffff',
    },
  },
});
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
